// ─────────────────────────────────────────────────────────────────────────────
// Os códigos do MySuite.
//
// Estes números decidem em qual FILA o ticket cai. Trocar um deles não dá erro
// em lugar nenhum: o ticket some da fila certa e aparece na errada, e alguém
// descobre dias depois.
//
// Ficam num arquivo só, sem dependência nenhuma, porque valem em TRÊS lugares
// que precisam continuar coerentes — o envio de atualização, o ticket novo e os
// tickets em massa — e porque as regras que os usam têm de poder ser testadas
// fora do app.
// ─────────────────────────────────────────────────────────────────────────────

export const STATUS = {
  EM_ATENDIMENTO: 36,
  CONCLUSAO: 3,
  AGUARDANDO_CLIENTE: 2,
  SETOR_SISTEMAS: 18,
  SUPORTE_AVANCADO: 91,   // Pendente análise suporte avançado
  COMERCIAL: 82,          // COM - Análise Comercial
  FILA_RETORNO: 5,
  AGENDADOS: 104,
};

export const OPERADOR = {
  SETOR_SISTEMAS: 108,
  ANALISE_SUPORTE: 106,
  MANTER_ATUAL: 0,
};

/**
 * Para quem o Suporte avançado é encaminhado — com ou sem possível falha de
 * sistema. A fila 106 fica só como destino de segurança, quando nenhum analista
 * foi escolhido.
 */
export const DESTINOS_SUPORTE_AVANCADO = [
  { codigo: 95, nome: 'Evandro' },
  { codigo: 100, nome: 'Luís Romero' },
];
